import { motion } from "framer-motion";
import styled from "styled-components";
import { Card, fadeIn, formatDate, PageContainer, SearchInput, Table, TableCell, TableHeader, TableRow } from "../styles/PageStyles";
import PageHeaderWithInfo from "../components/common/PageHeaderWithInfo";
import { faWindowRestore } from "@fortawesome/free-regular-svg-icons";
import { useNavigate } from "react-router-dom";
import { FaBuilding } from "react-icons/fa";
import { faBuilding } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import { getCompaniesByFilter } from "../services/companyService";

const Container = styled.div`
  padding: 1rem;
  max-width: 1600px;
  margin: 0 auto;
`;

const Header = styled.div`
  text-align: start;
  margin-bottom: 3rem;
  display: flex;
  align-item: center;
  justify-content: space-between
`;

const Title = styled.h1`
  font-size: 1.9rem;
  font-weight: 700;
  background: var(--gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: 'Orbitron', sans-serif;
  margin-bottom: 0.5rem;
`;

const Button = styled(motion.button)`
  padding: 0.9rem 2rem;
  background: ${props => {
    if (props.primary) return 'var(--gradient-primary)';
    if (props.secondary) return 'transparent';
    return '#ffffff';
  }};
  border: 1px solid ${props => {
    if (props.primary) return 'transparent';
    if (props.secondary) return 'var(--primary)';
    return 'rgba(0, 102, 255, 0.2)';
  }};
  border-radius: 8px;
  color: ${props => {
    if (props.primary) return 'white';
    if (props.secondary) return 'var(--primary)';
    return 'var(--text-primary)';
  }};
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: ${props => {
    if (props.primary) return 'var(--gradient-primary)';
    if (props.secondary) return 'rgba(0, 102, 255, 0.05)';
    return 'rgba(0, 102, 255, 0.03)';
  }};
    transform: translateY(-1px);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`;


const Company = () => {
    const navigate = useNavigate();
    const [searchTerm , setSearchTerm] = useState('');
    const [companies, setCompanies] = useState([]);
    const timerRef = useRef();

    const handleEditCompany = (companyId) => {
      navigate(`/manage/company/${companyId}`);
    }

    const navigeToCompany = () => {
        navigate('/create/company')
    }

    useEffect(() => {
      try {
        const fetchCompanies = async () => {
          const responce = await getCompaniesByFilter();
          setCompanies(responce || []);
        }
        fetchCompanies();
      } catch (error) {
        console.log("Error while fetching the companies.")
      }
    },[])

  const filteredCompanies = (companies || []).filter(company =>
    company?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    company?.status?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSearchChange = (value) => {

    if(timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      setSearchTerm(value);
    }, 300);
  }

  console.log("Company component")

    return (
           <PageContainer>
      <motion.div
        initial="hidden"
        animate="visible"
        variants={fadeIn}
      >
        <PageHeaderWithInfo
          icon={faBuilding}
          title="Company Details"
          description="The Company page is designed to manage the Comapny cration and users."
        >
          <div style={{ display: 'flex', gap: "1rem" }}>
            <SearchInput
              type="text"
              placeholder="Search Company..."
              onChange={(e) => handleSearchChange(e.target.value)}
              
            />
            <Button primary onClick={() => navigeToCompany()}>Add Company</Button></div>
        </PageHeaderWithInfo>
        <Card>
          <Table>
            <thead>
              <tr>
                <TableHeader>Name</TableHeader>
                <TableHeader>Description</TableHeader>
                <TableHeader>Status</TableHeader>
                <TableHeader>Last Updated</TableHeader>
                <TableHeader>Actions</TableHeader>
              </tr>
            </thead>
            <tbody> {
              filteredCompanies.length > 0 && filteredCompanies.map((company) => (
                <TableRow key={company.id}>
                  <TableCell>{company.name}</TableCell>
                  <TableCell>{company.description}</TableCell>
                  <TableCell>{company.status || '-'}</TableCell>
                  <TableCell>{formatDate(company.updated_at)}</TableCell>
                  <TableCell>
                    <div style={{display:'flex', gap:'10px', height:'100%', alignItems:'center'}}>
                      <Button primary style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }} onClick={() => handleEditCompany(company.id)}>Edit</Button>
                      <Button style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }}>Remove</Button>
                    </div>
                 </TableCell>
                </TableRow>
              ))
              }
            </tbody>
          </Table>
        </Card>
        {/* <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalCount={totalItems}
          setCurrentPage={setCurrentPage}
          setTotalPages={setTotalPages}
      /> */}
      </motion.div>
    </PageContainer>
    )
}


export default Company;